import './Committee.css';

export default function Committee({ conference = {} } = {}) {
    // Pobieramy dane o komitecie (lub pustą tablicę)
    const members = conference.committee || [];

    // Ustawienia wyświetlania komitetu z backendu
    const settings = conference.settings?.committee || {};

    // Domyślnie oba elementy są widoczne.
    // Ukrywane są tylko wtedy, gdy backend zwróci false.
    const showAffiliations = settings.showAffiliations !== false;
    const showRoles = settings.showRoles !== false;

    /* ==========================================================
       [REVERSIBLE] Podział na grupy (Scientific / Local)
       Aby przywrócić podział, po prostu odkomentuj poniższy
       blok oraz zmień listę renderowaną w HTML.
       ==========================================================
       const scientific = members.filter(m => m.is_local == 0);
       const local = members.filter(m => m.is_local == 1);
       ========================================================== */

    // Funkcja pomocnicza do renderowania pojedynczego członka komitetu
   const renderMember = (member) => {
    const fullName = `${member.first_name} ${member.last_name}`;

    const nameHtml = member.link
        ? `
            <a
                href="${member.link}"
                class="committee__member-link"
                target="_blank"
                rel="noopener noreferrer"
            >
                ${fullName}
            </a>
        `
        : fullName;

    return `
        <div class="committee__member">
            <h4 class="committee__member-name">
                ${nameHtml}
            </h4>

            ${showAffiliations && member.affiliation
                ? `<p class="committee__member-affiliation">${member.affiliation}</p>`
                : ''
            }

            ${showRoles && member.role
                ? `<span class="committee__member-role">${member.role}</span>`
                : ''
            }
        </div>
    `;
};

    return `
        <section class="committee" id="committee">
            <div class="container committee__container">

                <div class="committee__header">
                    <h2 class="about__title">
                        Committee
                    </h2>
                </div>

                ${members.length > 0 ? `
                    <div class="committee__content">

                        <!-- AKTUALNY STAN: Jedna wspólna lista wszystkich członków -->
                        <div class="committee__group">
                            <div class="committee__grid">
                                ${members.map(renderMember).join('')}
                            </div>
                        </div>

                        <!--
                        ==========================================================
                        [REVERSIBLE] STARY KOD Z PODZIAŁEM (W KOMENTARZU)
                        ==========================================================
                        ${/*
                        scientific.length > 0 ? `
                            <div class="committee__group">
                                <h3 class="committee__group-title">Scientific Committee</h3>
                                <div class="committee__grid">
                                    ${scientific.map(renderMember).join('')}
                                </div>
                            </div>
                        ` : ''}

                        ${local.length > 0 ? `
                            <div class="committee__group">
                                <h3 class="committee__group-title">Local Organizing Committee</h3>
                                <div class="committee__grid">
                                    ${local.map(renderMember).join('')}
                                </div>
                            </div>
                        ` : ''}
                        */ ''}
                        ========================================================== -->

                    </div>
                ` : `
                    <div class="committee__empty">
                        <p>Committee members will be announced soon.</p>
                    </div>
                `}

            </div>
        </section>
    `;
}
